import React from "react";

export type TGrokIconProps = React.SVGAttributes<SVGElement>;

export function GrokIcon({ ...rest }: TGrokIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <path d="M9.2691 14.7895L17.2479 8.89256C17.6391 8.60348 18.1982 8.71623 18.3846 9.1653C19.3655 11.5335 18.9272 
      14.3795 16.9755 16.3335C15.0239 18.2875 12.3083 18.716 9.82617 17.7401L7.11469 18.997C11.0037 21.6583 15.7263 
      21.0002 18.6774 18.0435C21.0182 15.6999 21.7432 12.5054 21.0653 9.6246L21.0714 9.63072C20.0884 5.3987 21.3131 
      3.70713 23.8219 0.248098C23.8812 0.166083 23.9406 0.0840663 24 0L20.6987 3.30524V3.29499L9.26708 14.7916" fill="black" />
      <path d="M7.62251 16.2229C4.83112 13.5532 5.31239 9.42167 7.69415 7.03915C9.45536 5.27579 12.341 4.5561 14.8599 
      5.61411L17.5653 4.36336C17.0779 4.01069 16.4532 3.63137 15.7364 3.36481C12.4966 2.03001 8.61778 2.69433 5.98412 
      5.3291C3.4508 7.86543 2.65415 11.7653 4.02218 15.0931C5.04411 17.5802 3.36888 19.3394 1.68137 21.1151C1.08336 
      21.7446 0.483314 22.3741 0 23.0404L7.62042 16.2249" fill="black" />
    </svg>
  );
}
